export default {
  baseURL: "",
}